import ExpenseDetails from "./Container"

export default ExpenseDetails
